






















import InputField from "./InputField";
import Multiselect from "vue-multiselect";
import { Employe } from "../../models/Employe";
import { EmployeApi } from "../../api/EmployeApi";
import { Config } from "../../utils/Config";

export default {
    name: "EmployeSelect",
    components: { InputField, Multiselect },
    props: {
        label: String,
        value: [Array, Employe, Object],
        multiple: Boolean,
        disponibilitesWeek: String,
        selectAll: Boolean,
        selectEmpty: Boolean,
    },
    data() {
        return {
            EmployeApi: new EmployeApi(),
            selected: null,
            options: [],
            vueMultiselectParams: Config.vueMultiselectParams,
        };
    },
    created() {
        this.loadEmployes();
        this.selected = this.value;
    },
    methods: {
        loadEmployes: function () {
            let self = this;

            self.EmployeApi.getAll({
                withDisponibilites: self.disponibilitesWeek,
                shared: true,
            }).then(function (res) {
                self.options = res;
                if (self.disponibilitesWeek) {
                    self.options = _.sortBy(self.options, "disponibilites");
                }
                if (self.selectEmpty) {
                    self.options.unshift({
                        fullName: "Non assigné",
                        id: -1,
                    });
                }
                if (self.selectAll) {
                    self.options.unshift({
                        fullName: self.multiple
                            ? "Sélectionner tout"
                            : "Tous les employés",
                        id: 0,
                    });
                }
                if (self.selected) {
                    let updatedData = _.find(self.options, {
                        id: self.selected.id,
                    });
                    _.assign(self.selected, updatedData);
                }
                self.$forceUpdate();
            });
        },
        customLabel: function ({ fullName, disponibilites }) {
            if (this.disponibilitesWeek) {
                return `${fullName} (${disponibilites})`;
            } else {
                return `${fullName}`;
            }
        },
        handleSelect(event) {
            // En sélection simple, « Tous les employés » est une option comme
            // une autre : la liste reste disponible pour changer de choix.
            if (this.multiple && parseInt(event.id) === 0) {
                // hide all items if select all
                for (let item of this.options) {
                    if (parseInt(item.id) > 0) {
                        _.remove(this.selected, item);
                        this.$emit("handle-select", item.value);
                    }
                }
                this.options = this.options.slice(0, 1);
            }
        },
        handleUnselect(event) {
            if (this.multiple && parseInt(event.id) === 0) {
                this.loadEmployes();
            }
        },
    },
    watch: {
        selected: function () {
            this.$emit("input", this.selected);
        },
        disponibilitesWeek: function () {
            this.loadEmployes();
        },
        value: function () {
            this.selected = this.value;
        },
    },
};
